export default "__VITE_ASSET__BHtH2t4F__"